import { HTMLAttributes } from "react";
import {
  UseCallbackWhenInViewConfig,
  useCallbackWhenInView,
} from "../hooks/useCallbackWhenInView";

type CallbackWhenInViewProps = UseCallbackWhenInViewConfig &
  HTMLAttributes<HTMLDivElement>;

export function CallbackWhenInView({
  callback,
  disabled,
  intersectionOptions,
  ...props
}: CallbackWhenInViewProps) {
  const ref = useCallbackWhenInView({
    callback,
    disabled,
    intersectionOptions,
  });

  return <div ref={ref} {...props} />;
}
